export default __webpack_public_path__ + "static/media/user_progress_report.9de2f8e1.png";